import { ExpandLess, ExpandMore, } from '@mui/icons-material';
import { Button, List, Collapse, ListItemButton, ListItemText, Grid, Paper, RadioGroup, FormControlLabel, Radio, FormLabel, ButtonGroup, Card, } from '@mui/material';
import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { Staff } from '../../../models'
import { MobxObjectsManager, useManualRemove } from '../../mobx-objs/mobx-manager';
import { AuthGroupData, PageState } from './auth-group-data';
import './scss/auth-group.style.scss'
import { GetThemeMode } from '../../../themes/tool';
import DialogComponent from '../../../component/dialog/dialog.component';
import ButtonComponent from '../../../component/button/button.component';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Save from '@mui/icons-material/Save';
import Close from '@mui/icons-material/Close';
import CustomTab from '../../../component/tab/custom.tab.component';
import EditIcon from '@mui/icons-material/Edit';
import { editAccountMobx } from '../account-manage/edit-account';
import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import BaseInput from '../../../component/form/base-input.component';
export const authGroupData = MobxObjectsManager.get(AuthGroupData);


const AuthGroupCom = observer((
    { enterCompType, accountInfo }:
        {
            // 新增 | 编辑 | 权限设置
            enterCompType?: 'ADD' | 'EDIT' | 'AU_SET',
            accountInfo?: Staff | null
        }) => {
    useManualRemove(AuthGroupData);

    useTranslation()

    useEffect(() => {
        // 该组件有用在两个不同地方，一个员工账号编辑，一个权限组
        authGroupData.setPageState(enterCompType ?? '', accountInfo ?? undefined);
    }, [accountInfo, enterCompType]);

    return (
        <div className='AuthGroup-panel-content'>
            <Card className='sidebar'>
                {authGroupData.pageState === PageState.AccountEdit ||
                    authGroupData.pageState === PageState.AccountAdd ? <></> : <div className='operation'>
                    <ButtonComponent
                        {...{
                            variant: 'contained',
                            size: 'small',
                            extraButtonStyle: 'add-button bigger',
                            titleText: i18n.t('dish_identify_page_text_new'),
                            action: 'ADD',
                            async: true,
                            handleClick: async () => {
                                await authGroupData.addBlankAuthGroup()
                            },
                            buttonStyle: { width: 150, height: 150 },
                            space: false
                        }}
                    />
                    <ButtonComponent
                        {...{
                            variant: 'contained',
                            size: 'small',
                            extraButtonStyle: 'copy-button bigger',
                            titleText: i18n.t('checkbox_table_text_copy'),
                            handleClick: async () => {
                                await authGroupData.copyAuthGroup()
                            },
                            async: true,
                            buttonStyle: { width: 150, height: 150 },
                            space: false
                        }}
                    >
                        <ContentCopyIcon />
                    </ButtonComponent>

                    <ButtonComponent
                        {...{
                            variant: 'contained',
                            size: 'small',
                            extraButtonStyle: 'delete-button bigger',
                            titleText: i18n.t('warrant_page_text_delete'),
                            action: 'DELETE',
                            handleClick: async () => {
                                await authGroupData.deleteGroup();
                            },
                            async: true,
                            color: 'secondary',
                            buttonStyle: { width: 150, height: 150 },
                            space: false
                        }}
                    />
                </div>}
                <LeftSidebar />
            </Card>
            <RightSideGroupsList compType={enterCompType ?? undefined} />
            <DialogComponent
                open={authGroupData.dialog.open}
                maxWidth={'xs'}
                defaultHeaderProps={{
                    title: authGroupData.dialog.title,
                    onClose: () => { authGroupData.setDialog({ open: false }) },
                }}
                footer={
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                        {authGroupData.dialog.option && authGroupData.dialog.option.map((e: any, i: number) => {
                            return (
                                <ButtonComponent
                                    key={`${i}`}
                                    variant={i === 0 ? 'contained' : 'outlined'}
                                    sx={{ width: '64px !important', marginLeft: '10px' }}
                                    async={true}
                                    handleClick={async () => {
                                        await e[1]();
                                    }}
                                    // eslint-disable-next-line react/no-children-prop
                                    children={e[0]}
                                />
                                // <Button
                                //     variant={i === 0 ? 'contained' : 'outlined'}
                                //     key={e[0]}
                                //     onClick={async () => await e[1]()}
                                // >
                                //     {e[0]}
                                // </Button>
                            )
                        })}
                    </div>
                }
            >
                {authGroupData.dialog.content ? authGroupData.dialog.content : authGroupData.dialog.message ?? ''}
            </DialogComponent>
        </div>
    )
});

const LeftSidebar = observer(() => (
    <CustomTab
        data={authGroupData.viewAuthGroups.map(e => ({ title: e.name }))}
        containerStyle={{
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}
        CustomComp={ItemGroup}
    />
));
const ItemGroup = observer(({ row, index }: any) => {
    const [isHovering, setIsHovering] = useState(false);
    const handleMouseOver = () => { setIsHovering(true); };
    const handleMouseOut = () => { setIsHovering(false); };
    return ((
        <div
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}>
            <ButtonGroup style={{ width: 130 }}>
                <Button
                    onClick={() => {
                        setIsHovering(true);
                        authGroupData.updateRoute(index);
                    }}
                    disabled={editAccountMobx.disabled}
                    style={{ display: 'flex', width: '100%' }}
                    color='primary'
                    variant={index === authGroupData.route ? 'contained' : 'outlined'}
                >
                    {row.title}
                </Button>
                {
                    isHovering && authGroupData.pageState === PageState.AuthGroupSetting ?
                        <Button disabled={editAccountMobx.disabled} onClick={() => {
                            authGroupData.updateEditingName('');
                            authGroupData.openEditNameDialog(
                                <NameEditInput
                                    nowName={authGroupData.getGroupUnit(index).name ?? ''}
                                />,
                                index
                            )
                        }} >
                            <EditIcon fontSize='small' style={{ width: 20, height: 20 }} />
                        </Button>
                        : <></>
                }
            </ButtonGroup>
        </div>
    ))
})

const NameEditInput = observer(
    function ({ nowName }: { nowName: string }) {
        const [name, setName] = useState(nowName);
        return (
            <BaseInput
                value={name}
                onChange={(e) => {
                    setName(e.target.value);
                    authGroupData.updateEditingName(e.target.value);
                }}
            >
            </BaseInput>
        )
    })

export const RightSideGroupsList = observer((props: { compType?: 'ADD' | 'EDIT' | 'AU_SET' | string }) => {
    const [openCWA, setOpenCWQ] = useState(true);
    const [openRWA, setOpenRWA] = useState(true);
    const [openShell, setOpenShell] = useState<boolean>(true);
    useTranslation()
    const cwa: [string, string, number][] = [
        ['auth_cwa_0', i18n.t('login_page_button_login'), 0],
        ['auth_cwa_1', i18n.t('auth_group_create_bill_auth'), 0],
        ['auth_cwa_2', i18n.t('auth_group_pay_for_bill_auth'), 0],
        ['auth_cwa_3', i18n.t('auth_group_table_management'), 1],
        ['auth_cwa_4', i18n.t('auth_group_browse_daily_bill_info'), 0],
        ['auth_cwa_5', i18n.t('auth_group_restaurant_info'), 1],
        ['auth_cwa_6', i18n.t('auth_group_dish'), 1],
        ['auth_cwa_7', i18n.t('auth_group_dish_menu'), 1],
        ['auth_cwa_8', i18n.t('auth_group_browse_customer_address_list'), 1],
        ['auth_cwa_9', i18n.t('auth_group_browse_company_address_list'), 1],
        ['auth_cwa_10', i18n.t('auth_group_eletronic_invoice'), 1],
        ['auth_cwa_11', i18n.t('auth_group_manager_feature_exchange_job'), 1],
        ['auth_cwa_12', i18n.t('auth_group_manager_feature_data_analyics'), 1],
        ['auth_cwa_13', i18n.t('auth_group_manager_feature_history_order'), 1],
    ];
    const rwa: [string, string, number][] = [
        ['auth_rwa_0', i18n.t('login_page_button_login'), 0],
        ['auth_rwa_1', i18n.t('auth_group_create_bill_auth'), 0],
        ['auth_rwa_2', i18n.t('auth_group_pay_for_bill_auth'), 0],
        ['auth_rwa_3', i18n.t('auth_group_browse_customer_address_list'), 1],
        // ['auth_rwa_4', i18n.t('auth_group_browse_daily_bill_info'), 1],
    ];
    // shell 权限（RBP Cloud、菜单商店上传等）
    const shell: [string, string, number][] = [
        ['auth_shell_1', i18n.t('RBP Cloud'), 0],
        ['auth_shell_2', i18n.t('auth_group_shell_menu_store_upload'), 0],
    ];

    return (
        <div className='right-content'>
            {
                props?.compType !== 'ADD' &&
                <Collapse in={authGroupData.hadModified} timeout='auto' unmountOnExit
                    style={{ width: '100%', }}>
                    <Paper className='op-card'>
                        <Grid container spacing={2} >
                            <Grid item>
                                <ButtonComponent
                                    async
                                    variant='outlined'
                                    handleClick={async () => {
                                        await authGroupData.confirmSave()
                                    }}
                                    titleText={i18n.t('general_text_save')}
                                >
                                    <Save className='iconColor' />
                                </ButtonComponent>
                            </Grid>
                            <Grid item>
                                <ButtonComponent
                                    async
                                    variant='outlined'
                                    handleClick={async () => {
                                        await authGroupData.cancelSave()
                                    }}
                                    titleText={i18n.t('general_button_cancel')}
                                >
                                    <Close />
                                </ButtonComponent>
                            </Grid>
                        </Grid>
                    </Paper>
                </Collapse>
            }
            <List
                sx={{ width: '100%', bgcolor: 'background.paper' }}
                component='nav'
                aria-labelledby='nested-list-subheader'
            >
                <Paper style={{ borderRadius: 10, overflow: 'hidden', marginBottom: 10, paddingTop: 5 }}>
                    <ListItemButton
                        style={{ backgroundColor: GetThemeMode() === 'dark' ? '#58606f' : '#d4e3ff', }}
                        onClick={() => setOpenCWQ(!openCWA)}
                    >
                        <ListItemText primary={'CWA'} />
                        {openCWA ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openCWA} timeout='auto' unmountOnExit sx={{ paddingX: 5 }}>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                            {
                                authGroupData.getUnitList('cwa').map(
                                    keyName => {
                                        const cur: [string, string, number] = cwa.find(
                                            config => keyName === config[0])!;
                                        const name = cur?.[1] ?? '';
                                        const select = (authGroupData.getGroupUnit(authGroupData.route) as any)[keyName] ?? 0;
                                        const selection = cur?.[2] ?? 0;
                                        return <AuthUnit
                                            name={name as string}
                                            key={keyName}
                                            keyName={keyName}
                                            selection={selection} select={select}
                                        />
                                    })
                            }
                        </Grid>
                    </Collapse>
                </Paper>
                <Paper style={{ borderRadius: 10, overflow: 'hidden', marginBottom: 10, paddingTop: 5 }}>
                    <ListItemButton
                        style={{ backgroundColor: GetThemeMode() === 'dark' ? '#58606f' : '#d4e3ff', }}
                        onClick={() => setOpenRWA(!openRWA)}
                    >
                        <ListItemText primary={'RWA'} />
                        {openRWA ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openRWA} timeout='auto' unmountOnExit sx={{ paddingX: 5 }}>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                            {
                                authGroupData.getUnitList('rwa').map(
                                    keyName => {
                                        const cur: [string, string, number] = rwa.find(
                                            config => keyName === config[0])!;
                                        const name = cur?.[1] ?? '';
                                        const select = (authGroupData.getGroupUnit(authGroupData.route) as any)[keyName] ?? 0;
                                        const selection = cur?.[2] ?? 0;
                                        return (
                                            <AuthUnit
                                                name={name as string}
                                                key={keyName}
                                                keyName={keyName}
                                                selection={selection} select={select}
                                            />
                                        )
                                    })
                            }
                        </Grid>
                    </Collapse>
                </Paper>
                <Paper style={{ borderRadius: 10, overflow: 'hidden', marginBottom: 10, paddingTop: 5 }}>
                    <ListItemButton
                        style={{ backgroundColor: GetThemeMode() === 'dark' ? '#58606f' : '#d4e3ff', }}
                        onClick={() => setOpenShell(!openShell)}
                    >
                        <ListItemText primary={'Shell'} />
                        {openShell ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={openShell} timeout='auto' unmountOnExit sx={{ paddingX: 5 }}>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                            {
                                authGroupData.getUnitList('shell').map(
                                    keyName => {
                                        const cur: [string, string, number] = shell.find(
                                            config => keyName === config[0])!;
                                        const name = cur?.[1] ?? '';
                                        const select = (authGroupData.getGroupUnit(authGroupData.route) as any)[keyName] ?? 0;
                                        const selection = cur?.[2] ?? 0;
                                        return (
                                            <AuthUnit
                                                name={name as string}
                                                key={keyName}
                                                keyName={keyName}
                                                selection={selection} select={select}
                                            />
                                        )
                                    })
                            }
                        </Grid>
                    </Collapse>
                </Paper>
            </List>
        </div>
    )
});

const AuthUnit = observer((
    { name, selection, select, keyName }: { keyName: string, name: string, selection: number, select: number }) => {
    const constSelection = [
        [i18n.t('auth_group_no_auth'), i18n.t('auth_group_had_auth')],
        [i18n.t('auth_group_no_auth'), i18n.t('auth_group_only_read'), i18n.t('auth_group_rw')]
    ]

    return (
        <Grid key={keyName} item xs={2} sm={4} md={4} marginBottom={3} style={{ borderBottom: '1px solid grey' }}>
            <FormLabel sx={{ fontWeight: 500 }}>{name}</FormLabel>
            <RadioGroup
                onChange={(e, v) => {
                    if (editAccountMobx.disabled) return;
                    authGroupData.handleChange(v, keyName)
                }}
                row
                aria-disabled={editAccountMobx.disabled}
                aria-labelledby='demo-row-radio-buttons-group-label'
                name='row-radio-buttons-group'
                value={select}
                style={{
                    backgroundColor: authGroupData.operationList.get(keyName) !== undefined ? '#bdbfc566' : 'transparent',
                    borderRadius: 5,
                    paddingLeft: 10
                }}
            >
                {
                    constSelection[selection].map((e, i) => (
                        <FormControlLabel key={e} value={i} labelPlacement='end' control={<Radio size='small' />} label={e} />
                    ))
                }
            </RadioGroup>
        </Grid>
    )
});



export default AuthGroupCom;